import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  CREATEMEMORIALS: {
    path: `${baseRoutes.userBaseRoutes}create-memorials`,
  },
};

export default accessRoute;
